/** Insights service (not the CRM): see `@/api-client/insights`. */
export const contactRuleSettingsApiPaths = {
  settings: '/api/settings/sending-companies',
  company: (companyUuid: string) =>
    `/api/settings/sending-companies/${encodeURIComponent(companyUuid)}`
};
